// extracted by mini-css-extract-plugin
module.exports = {"iconSize":"styles_iconSize__36_Bm"};